<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h3>Oops! You are not Authorized!</h3>
      <h1><span>4</span><span>0</span><span>1</span></h1>
    </div>
    <h2>{{ 'app.not_found.not_authorised' | translate }}</h2>
  </div>
</div>
